module.exports = __webpack_public_path__ + "static/img/4_1_3.0bbfb0a5.jpg";